import { combineEpics, ofType } from 'redux-observable'
import { logObservableError } from '../utilities/logs'
import { cond, T } from 'ramda'
import {
  debounceTime,
  filter,
  fromEvent,
  map,
  take,
  withLatestFrom,
} from 'rxjs'
import { load, refresh } from '../store/modules/viewport'
import { ROUTE_FOUND } from '../store/modules/router'
import { HYDRATION_COMPLETED } from '../store/modules/app'
import { DESKTOP_VIEWPORT, TABLET_VIEWPORT, MOBILE_VIEWPORT } from '../utilities/constants'

// getViewport :: Number -> String
const getViewport = width => cond([
  [width => width <= 600, () => MOBILE_VIEWPORT],
  [width => width <= 960, () => TABLET_VIEWPORT],
  [T, () => DESKTOP_VIEWPORT],
])(width)

// loadEpic :: Epic -> Observable Action.LOAD
export const loadEpic = (action$, _, { logger, window }) =>
  action$.pipe(
    ofType(ROUTE_FOUND, HYDRATION_COMPLETED),
    take(1),
    map(() => load(getViewport(window.outerWidth))),
    logObservableError('viewport :: loadEpic', logger),
  )

// refreshAfterResizeEpic :: Epic -> Observable Action.REFESH
export const refreshAfterResizeEpic = (action$, state$, { logger, window }) =>
  fromEvent(window, 'resize').pipe(
    debounceTime(200),
    withLatestFrom(state$),
    filter(([_, state]) => state.viewport.viewport !== null
      && state.viewport.viewport !== getViewport(window.outerWidth),
    ),
    map(() => refresh(getViewport(window.outerWidth))),
    logObservableError('viewport :: refreshAfterResizeEpic', logger),
  )

export default combineEpics(
  loadEpic,
  refreshAfterResizeEpic,
)
